import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=54baa9af&scoped=true&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"
import style0 from "./manager.vue?vue&type=style&index=0&id=54baa9af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baa9af",
  null
  
)

export default component.exports